/**
 * React hook for consuming the notification store.
 *
 * Uses useSyncExternalStore for tear-free reads.
 */
import { useSyncExternalStore, useMemo } from 'react';
import {
  subscribe,
  getSnapshot,
  getUnreadCount,
  getGroupedNotifications,
  markRead,
  markAllRead,
  removeNotification,
} from './notificationStore';

export function useNotifications() {
  const notifications = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  const unreadCount = useMemo(
    () => notifications.filter((n) => !n.isRead).length,
    [notifications]
  );

  // Grouped view: collapses unread chat_messages from the same sender.
  // `notifications` is the recompute trigger — getGroupedNotifications() reads
  // the store directly, so we recompute whenever the store snapshot changes.
  const grouped = useMemo(() => {
    void notifications;
    return getGroupedNotifications();
  }, [notifications]);

  return {
    notifications,
    grouped,
    unreadCount,
    markRead,
    markAllRead,
    removeNotification,
  };
}
